import { FC } from "react";
import Smile from "./types/Smile";
import Settings from "./types/Settings";
import Link from "./types/Link";
import Loading from "./types/Loading";
import AddCircle from "./types/AddCircle";
import Archive from "./types/Archive";
import Leave from "./types/Leave";
import Group from "./types/Group";
import ChevronVertical from "./types/ChevronVertical";
import X from "./types/X";
import PersonAdd from "./types/PersonAdd";
import Lock from "./types/Lock";
import Reorder from "./types/Reorder";
import Chat from "./types/Chat";
import CheckFill from "./types/CheckFill";
import CrossFill from "./types/CrossFill";
import GroupMenu from "./types/GroupMenu";
import SortAlphabetically from "./types/SortAlphabetically";
import ArrowDownCircleFill from "./types/ArrowDownCircleFill";
import ArrowUpCircleFill from "./types/ArrowUpCircleFill";
import Heart from "./types/Heart";
import ArrowLeft from "./types/ArrowLeft";
import CrossFillGray from "./types/CrossFillGray";

const icons = {
  smile: Smile,
  link: Link,
  settings: Settings,
  loading: Loading,
  "add-circle": AddCircle,
  archive: Archive,
  leave: Leave,
  group: Group,
  "chevron-vertical": ChevronVertical,
  x: X,
  "person-add": PersonAdd,
  lock: Lock,
  reorder: Reorder,
  chat: Chat,
  "check-fill": CheckFill,
  "cross-fill": CrossFill,
  "cross-fill-gray": CrossFillGray,
  "group-menu": GroupMenu,
  "sort-alphabetically": SortAlphabetically,
  "arrow-down-circle-fill": ArrowDownCircleFill,
  "arrow-up-circle-fill": ArrowUpCircleFill,
  heart: Heart,
  "arrow-left": ArrowLeft,
};

export type IconType = keyof typeof icons;

type IconProps = {
  type: IconType;
  className?: string;
};

export const Icon: FC<IconProps> = ({ type, className }) => {
  const IconComponent = icons[type];

  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <IconComponent />
    </svg>
  );
};
